import React, { useState } from "react";
import { Plus } from "lucide-react";
import { GALLERY as items } from "@/lib/constants";

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="velvet-cream py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="md:col-span-7">
            <div className="overline mb-6 flex items-center">
              <span className="gold-rule" />
              Munkáink
            </div>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-[#0A1228]">
              Néhány friss
              <span className="italic text-[#1E47A8]"> darab.</span>
            </h2>
          </div>
          <div className="md:col-span-5 flex items-end">
            <p className="text-sm md:text-base text-[#4A5468] leading-relaxed font-light">
              Minden bútor más történetet mesél. Lent néhány a közelmúltbeli munkáinkból — kattintson rá és nézze meg részletesebben.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((it, idx) => (
            <button
              key={idx}
              data-testid={`gallery-item-${idx}`}
              onClick={() => setActive(it)}
              className="group relative overflow-hidden bg-[#ECE7DE] text-left"
              aria-label="Nagyítás"
            >
              <div className="overflow-hidden">
                <img
                  src={it.src}
                  alt=""
                  className="w-full h-[340px] md:h-[400px] object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <div className="absolute bottom-5 right-5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <Plus
                  size={22}
                  className="text-[#F5F2EC] drop-shadow-[0_2px_8px_rgba(10,18,40,0.6)] transition-transform duration-300 group-hover:rotate-90"
                />
              </div>
            </button>
          ))}

          {/* All gallery items rendered above */}
        </div>
      </div>

      {/* Lightbox */}
      {active && (
        <div
          className="fixed inset-0 z-50 bg-[#0A1228]/95 flex items-center justify-center p-4 md:p-12 cursor-zoom-out"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <div className="relative max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={active.src}
              alt=""
              className="w-full max-h-[85vh] object-contain"
            />
            <button
              onClick={() => setActive(null)}
              className="absolute -top-3 -right-3 bg-[#D4B47A] text-[#0A1228] rounded-full w-9 h-9 flex items-center justify-center font-bold"
              data-testid="gallery-lightbox-close"
              aria-label="Bezárás"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
